module.exports = __webpack_public_path__ + "static/img/color-palette-13.9b15d16d.svg";